import { DateTime } from "luxon";

import { get, post } from "@readai/common/api";
import type {
  ApiTeamsConversationResponse,
  PostTopicToTeamsChannelBody,
  TeamsConversation,
} from "@readai/common/types/teamsTypes";
import { sanitize } from "@readai/common/utils";

export const listConversations = async (): Promise<TeamsConversation[]> => {
  const response: ApiTeamsConversationResponse = await get(
    "/integrations/microsoft-teams-push/conversations",
    { withCreds: true },
  );

  return response.data ?? [];
};

export const postTopicToConversation = async (
  body: PostTopicToTeamsChannelBody,
): Promise<void> => {
  const postBody = {
    ...body,
    timezone: DateTime.now().zoneName,
  };

  return post(
    "/integrations/microsoft-teams-push/share-topic",
    sanitize(postBody),
    { withCreds: true },
  );
};
